import { connect } from 'react-redux';
import get from 'lodash.get';
import { downloadPdf, closeSnackbar } from '../../../api/pdfGeneration/shared/pdfActions';
import { getMergedStudentsData } from '../../../features/pdfGeneration/shared/homeConnect/utils';
import PdfGenerator from '../../../features/pdfGeneration/shared/PdfGenerator';
import { selectors } from '../../../root/reading/root';
import { MEASURE } from '../../../constants/reading/MeasuresConstants';
import { HC_TEMPLATES, HC_PAGES } from '../../../constants/shared/HomeConnectConstants';

const { OVERALL, TRC, OL, VOCABO, SPELLING, RAN, TRO, DO } = MEASURE;
const { READING } = HC_TEMPLATES;
const { D8_TRC_PAGE, ELM_PAGE, ONLINE_PAGE } = HC_PAGES;

export const HC_LETTER_PAGES = [
    {
        pageKey: D8_TRC_PAGE,
        summaryMeasures: [OVERALL, TRC, OL],
    },
    {
        pageKey: ELM_PAGE,
        summaryMeasures: [VOCABO, SPELLING, RAN],
    },
    {
        pageKey: ONLINE_PAGE,
        summaryMeasures: [TRO, DO],
    },
];

const mapStateToProps = state => {
    const { teacherName: userFirstName, teacherSurname: userLastName } =
        selectors.getClassOrGroupOfficialTeacher(state);
    return {
        userFirstName,
        userLastName,
        letterType: READING,
        letterPages: HC_LETTER_PAGES.map(page => page.pageKey),
        pdfConfiguration: selectors.getPDFConfiguration(state),
        isEnrollmentDataFetched: selectors.isDataFetched(state),
        isDataReady: selectors.isDataReady(state),
        studentsData: selectors.getAllStudentsInClassData(state),
        studentsDataForAllPMGraphs: selectors.getStudentsDataByMeasuresForAllPMGraphs(state),
        troClassSummaryData: selectors.getTroClassSummaryPdfData(state),
        dualLanguageClassSummaryData: selectors.getDualLanguageClassSummaryPdfData(state),
        classSummaryData: selectors.getClassSummaryPdfData(state),
        hasLegendForAllPMGraphs: true,
        windowDates: selectors.getWindowDates(state),
        currentSchoolYear: selectors.getCurrentSchoolYear(state),
        districtName: selectors.getDistrictInfo(state).name,
        schoolName: selectors.getSchoolInfo(state).name,
        classOrGroupName: selectors.getClassOrGroupInfo(state).name,
        isSnackbarOpen: selectors.isSnackbarOpen(state),
        accountInfo: selectors.getHomeConnectAccountInfo(state),
        students: getMergedStudentsData(
            selectors.getHomeConnectPDFStudentsData(state),
            get(selectors.getPDFConfiguration(state), 'selectedStudentsData', []),
            HC_LETTER_PAGES,
        ),
    };
};

const mapDispatchToProps = dispatch => ({
    downloadPdf: (url, pdfConfiguration, pdfData) => {
        dispatch(downloadPdf(url, pdfData, `${pdfConfiguration.fileName}.pdf`));
    },
    onCloseSnackbar: () => {
        dispatch(closeSnackbar());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(PdfGenerator);
